import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../components/header/header.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [RouterOutlet, CommonModule, HeaderComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="h-screen bg-ds-bg flex flex-col overflow-hidden">
      <app-header class="flex-none"></app-header>
      <main class="flex-1 overflow-hidden">
        <div class="h-full w-full bg-ds-surface overflow-hidden">
          <router-outlet></router-outlet>
        </div>
      </main>
    </div>
  `
})
export class MainLayoutComponent {
}
